import { useFieldArray } from 'react-hook-form'
import RuleEntryConditionCell from './RuleEntryConditionCell'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import styles from './RuleEntryCondition.module.sass'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useParams } from 'react-router-dom'

const RuleConditions = ({ path, options, onRemove, onAppend, hasOutput }) => {
	const { fields, append, remove } = useFieldArray({
		name: `${path}.logicalCondition`,
		keyName: 'key',
	})
	const params = useParams()

	const hasUser = !!params?.userId

	return (
		<div className={styles['root']}>
			<VStack
				className={`${styles['actions']} ${styles['root']}`}
				justify='space-between'
			>
				{onRemove && (
					<ActionButton
						className={styles['action-button']}
						icon='remove'
						onClick={onRemove}
						danger
					/>
				)}
				{onAppend && (
					<ActionButton
						className={styles['action-button']}
						icon='fast-downward'
						onClick={onAppend}
					/>
				)}
			</VStack>
			<span
				className={`${styles['logical-condition']} ${
					hasUser && !hasOutput ? styles['--user-settings'] : ''
				}`}
				style={{ '--num-items': Math.max(1, fields.length - 1) }}
			>
				{fields.map(({ key, option, optionGroup }, index) => (
					<RuleEntryConditionCell
						key={key}
						path={`${path}.logicalCondition.${index}`}
						option={option}
						optionGroup={optionGroup}
						options={options}
						onRemove={() => {
							remove(index)
						}}
						onAppend={() => {
							append({})
						}}
						actions={
							<span
								className={`${styles['actions']} ${
									styles['inner']
								} ${
									fields.length === 1
										? styles['first-entry']
										: ''
								}`}
							>
								{fields.length > 1 && (
									<ActionButton
										className={styles['action-button']}
										icon='remove'
										onClick={() => {
											remove(index)
										}}
										danger
									/>
								)}
								{index === fields.length - 1 && (
									<ActionButton
										className={styles['action-button']}
										icon='fast-forward'
										onClick={() => {
											append({})
										}}
									/>
								)}
							</span>
						}
					/>
				))}
			</span>
		</div>
	)
}

export default RuleConditions
